import {Message} from "@2d-front-monorepo/design-library";
import {JSX} from "react";

export default function InvalidReservation({reservationId}: { reservationId: string | undefined }): JSX.Element {
	return <Message title={{text: `Invalid reservation id: [${reservationId}]`}} type="error"/>;
}
